exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-0feacc5d] {\n  padding-top: 26.66667vw;\n  text-align: center;\n}\n.container .tips-img[data-v-0feacc5d] {\n  margin-top: 8vw;\n}\n", ""]);

// exports
